<header *ngIf="(authenticationService.organisation$ | async)">
  <img src="{{ (authenticationService.organisation$ | async)?.logo }}" alt="{{ (authenticationService.organisation$ | async)?.display_name }}">
</header>
<fury-page-layout>
  <fury-page-layout-content @fadeInUp>
    <fury-container>
      <mat-progress-spinner *ngIf="isLoading" mode="indeterminate" diameter="32"></mat-progress-spinner>
      <div fxFlex="100" fxLayout="column" *ngIf="!isLoading">
        <h1>Uw melding
          <ng-container *ngIf="webformService?.report?.number">met nummer {{ webformService.report.number }}</ng-container>
          hebben wij in goede orde ontvangen.
        </h1>
        <p class="max-width">
          Vriendelijk bedankt voor uw melding. Wij hebben deze in goede orde ontvangen. Bij telefonisch contact is het altijd handig om uw meldnummer bij de
          hand te hebben.
        </p>
        <ng-container *ngIf="!webformService.report && !isLoading">
          <fury-alert-box class="warn" style="margin: 30px auto;padding:15px 45px;">
            Er is geen melding gevonden.
          </fury-alert-box>
        </ng-container>
        <h2>Wat gebeurt er met uw melding?</h2>
        <p class="max-width">Wij proberen uw melding altijd zo snel mogelijk op te lossen. Hierbij hanteren wij de volgende stappen die gemiddeld 2 werkdagen
          duurt om op te lossen.</p>
        <ul>
          <li>Melding wordt toegekend aan de verantwoordelijke afdeling</li>
          <li>U ontvangt een notificatie bij een toegekende melding</li>
          <li>Melding wordt ingepland</li>
          <li>Melding wordt uitgevoerd</li>
          <li>U ontvangt een terugkoppeling indien de melding is opgelost</li>
        </ul>
        <div fxFlex fxLayout="column" fxLayoutGap="36px">
          <a *ngIf="webformService.report?.website_url" color="primary" mat-button href="{{ webformService.report.website_url }}">
            Scherm sluiten, terug naar de homepage
          </a>
          <h2>Heeft u uw melding anoniem ingediend?</h2>
          <p class="max-width">
            Door het opslaan van onderstaande link heeft u inzicht in de actuele status van uw melding. Na het sluiten van deze pagina wordt deze
            link niet meer weergegeven.
          </p>
          <a href="{{ webformService.report?.track_and_trace_url }}" color="primary" mat-button target="_blank">
            Track & trace
          </a>
        </div>
      </div>
    </fury-container>
  </fury-page-layout-content>
</fury-page-layout>
